import React, { Component } from 'react';
import TextField from "@material-ui/core/TextField";
import Button from "@material-ui/core/Button";
import FormHelperText from "@material-ui/core/FormHelperText";
import FormControl from "@material-ui/core/FormControl";
import queryString from "querystring";
import {API_BASE_URL} from "../constatns";
import Alert from "react-bootstrap/Alert";

class ResetPasswordPage extends Component {

	constructor(props) {
		super(props);
		this.state = {
			verify: false,
			requestVerify: true,
			success: false
		}
		this.handleChange = this.handleChange.bind(this);
		this.changePassword = this.changePassword.bind(this);

		const param = queryString.parse((this.props.location.search).replace("?",""));
		// const checkDate = moment(new Date(1 * (param.verify))).format('YYYY-MM-DD HH:mm');
		// const now = moment(new Date()).format('YYYY-MM-DD HH:mm');

		if(param.verify < new Date().getTime()) {
			this.setState({requestVerify: false})
		}

	}

	componentDidMount() {
	}

	handleChange(event) {
		const _new = (document.getElementById('new').value);
		if(event.target.value != _new) this.setState({verify: false});
		else this.setState({verify: true});
	}

	changePassword(event) {

		const param = queryString.parse((this.props.location.search).replace("?",""));
		const obj = {
			newPassword : document.getElementById('new').value,
			email: param.email,
			code: param.code
		}
		fetch(API_BASE_URL+'/user/resetPassword/'+this.props.match.params.id, {
			method: 'PUT',
			headers: {'Content-Type': 'application/json'},
			body: JSON.stringify(obj)
		}).then(res => res.text())
		.then(body => {
			console.log(body)
			if(JSON.parse(body).res == 'success') {
				this.setState({success: true})
			} else {
				this.setState({verify: false, requestVerify: false})
			}
		});
	}

	render() {

		return (
			<div className="share-container">
				<div className="detail-banner"></div>
				<div className="share-content">
					<h1 className="share-title">Reset Password</h1>
					<div className="or-separator">
						<span className="or-text">HALASZ</span>
					</div>

					{this.state.success ?
						<Alert variant={'success'}>
							비밀번호가 변경되었습니다. <br></br> HALASZ APP을 통해 로그인하세요.
						</Alert>
						:
						<div>
							{!this.state.requestVerify ?
								<Alert variant={'danger'}>
									유효하지 않은 요청입니다.
								</Alert>
								:
								<form noValidate autoComplete="off">
									<FormControl error>
										<TextField type="password" required name="new" id="new" label="New Password"
															 style={{marginBottom: '10px'}}/>
										<TextField type="password" required name="check" id="check" label="Confirm Password"
															 onChange={this.handleChange}/>
										{!this.state.verify
										&& document.getElementById('check')
										&& (document.getElementById('check').value.length > 0) ?
											<FormHelperText>confirm password not matched.</FormHelperText> : ''}
										<Button variant="contained" color="secondary" style={{marginTop: '30px'}}
														onClick={this.changePassword}
														disabled={this.state.verify ? false : true}>
											Change Password
										</Button>
									</FormControl>
								</form>
							}
						</div>
					}
				</div>
			</div>
		);
	}
}


export default ResetPasswordPage
